import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";

import { SREEMenu } from "../../../components/Layout/DepartmentMenu";

import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import { fetchData } from "../../../utils/fetchData";
import { getAPIPath, getPageTitle } from "../../../utils/getDomainData";
const SREEIndustryInteraction = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.companiesList, setData);
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Industry Interaction – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Industry interaction"
          pageName="Industry interaction"
          breadcrumbsClass="breadcrumb-bg"
        />
        <SREEMenu />

        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col-lg-9 md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3 title="University – Industry interaction">University – Industry interaction</h3>
                    <h4 title="LIST OF COMPANIES FOR PROJECT WORK- M.TECH (RE)">LIST OF COMPANIES FOR PROJECT WORK- M.TECH (RE):</h4>
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">S.No</th>
                          <th scope="col">NAME OF THE COMPANY</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.map((obj, index) => (
                          <tr>
                            <td>{index + 1}.</td>
                            <td>{obj?.attributes?.Company_Name}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SREEIndustryInteraction;
